import { FiCopy } from "react-icons/fi";
import toast from "react-hot-toast";

import bkash from "../assets/payment/bkash.png";
import nagad from "../assets/payment/nagad.png";

const PaymentOptions = () => {

  const payments = [
    {
      name: "bKash",
      icon: bkash,
      number: "0130000000",
    },
    {
      name: "Nagad",
      icon: nagad,
      number: "0130000000",
    },
  ];

  const copyToClipboard = async (number) => {
    try {
      await navigator.clipboard.writeText(number);
      alert("নাম্বার কপি হয়েছে!")
      toast.success("নাম্বার কপি হয়েছে!");
    } catch {
      toast.error("কপি করা যায়নি!");
    }
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-xl mx-auto">
      {payments.map((payment) => (
        <div
          key={payment.name}
          className="bg-[#E6F0E4] rounded-xl shadow-md hover:shadow-xl transition-all duration-300 p-4 flex flex-col"
        >
          {/* Header */}
          <div className="flex items-center justify-between mb-3">
            <img
              src={payment.icon}
              alt={payment.name}
              className="h-12 w-14 object-contain"
            />

            <FiCopy
              onClick={() => copyToClipboard(payment.number)}
              className="text-gray-600 hover:text-gray-900 cursor-pointer transition"
              size={20}
            />
          </div>

          {/* Number */}
          <span className="text-gray-700 font-semibold">
            {payment.number} <span className="text-sm">(Personal)</span>
          </span>
        </div>
      ))}
    </div>
  );
};

export default PaymentOptions;
